import { getTableTasksForWaiters } from "../../config/Services";

// Singleton poller for restaurant waiter table tasks. Kept out of the React
// component lifecycle on purpose: the navbar can mount/re-mount many times, but
// there must only ever be ONE timer and ONE in-flight fetch loop — otherwise the
// component's per-mount fetch fires repeatedly (the "called every 2-3s" problem).

let intervalId = null;
let subscribers = new Set();
let latest = [];
const INTERVAL = 3 * 60 * 1000; // 3 minutes

const notify = () => subscribers.forEach((cb) => cb(latest));

const poll = () => {
  // Logged out (logout wipes localStorage): stop the timer entirely so no
  // polling survives past signout, whichever logout path was taken.
  if (!localStorage.getItem("orgId") || !localStorage.getItem("locId")) {
    stopTableTaskPolling();
    return;
  }

  // Only restaurants have table tasks.
  if (localStorage.getItem("retailType") !== "RESTAURANT") return;

  const payload = {
    organisationId: localStorage.getItem("orgId"),
    locationId: localStorage.getItem("locId"),
    layoutId: localStorage.getItem("layoutId"),
    status: "REQUESTED",
    page: 0,
    size: 50,
  };

  getTableTasksForWaiters(payload)
    .then((res) => {
      if (res?.data?.data?.content) {
        latest = res?.data?.data?.content;
        notify();
      }
    })
    .catch(() => {});
};

export const subscribeTableTasks = (cb) => {
  subscribers.add(cb);
  if (latest.length) cb(latest); // replay last known value to new subscribers
  return () => subscribers.delete(cb);
};

export const startTableTaskPolling = () => {
  if (intervalId) return; // singleton guard — one timer for the whole app
  if (!localStorage.getItem("orgId") || !localStorage.getItem("locId")) return;
  poll(); // immediate first fetch
  intervalId = setInterval(poll, INTERVAL);
};

// Fire an immediate fetch outside the 3-minute cadence — used when a view opens
// on demand (e.g. the drawer's "Table Requests" tab) so it isn't stuck showing
// stale data until the next interval tick.
export const refreshTableTasks = () => poll();

export const stopTableTaskPolling = () => {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
};
